/**
 * Catch-all 404 inside the gated shell.
 */
import { Link } from 'react-router-dom';
import { HOME_PATH } from '@/routes/home';

export function NotFound() {
  return (
    <section>
      <h1>Not found</h1>
      <p>That page doesn’t exist.</p>
      <Link to={HOME_PATH}>Go to Reservations</Link>
    </section>
  );
}
